module.exports = __webpack_public_path__ + "static/media/promo.c51c81a3.png";